var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"footer"}},[_vm._v(" Syn R G Consulting Inc. © "+_vm._s(_vm.year)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }